import React, { useEffect, useState } from "react";
import API from "../api";
import { Table, Button, Form, Row, Col, Tabs, Tab } from "react-bootstrap";

export default function AdminDashboard() {
  const [activeTab, setActiveTab] = useState("content");

  const [content, setContent] = useState([]);
  const [news, setNews] = useState([]);
  const [teachers, setTeachers] = useState([]);

  // ================= EDIT IDS =================
  const [editContentId, setEditContentId] = useState(null);
  const [editNewsId, setEditNewsId] = useState(null);
  const [editTeacherId, setEditTeacherId] = useState(null);

  // ================= CONTENT FORM =================
  const [form, setForm] = useState({
    type: "banner",
    title: "",
    description: "",
    position: 1,
    image: null,
  });

  // ================= NEWS FORM =================
  const [newsForm, setNewsForm] = useState({
    title: "",
    content: "",
    image: null,
  });

  // ================= TEACHER FORM =================
  const [teacherForm, setTeacherForm] = useState({
    name: "",
    position: "",
    description: "",
    photo: null,
  });

  const [gallery, setGallery] = useState([]);
  const [editGalleryId, setEditGalleryId] = useState(null);
  const [galleryForm, setGalleryForm] = useState({ title: "", category: "", images: [] });

  // ================= LOAD ALL DATA =================
  const loadAll = async () => {
    try {
      const [c, n, t, g] = await Promise.all([
        API.get("/content"),
        API.get("/news"),
        API.get("/teachers"),
        API.get("/gallery")
      ]);

      setContent(c.data);
      setNews(n.data);
      setTeachers(t.data);
      setGallery(g.data.data || []);
    } catch (err) {
      console.error("Gagal load data:", err);
    }
  };

  useEffect(() => {
    loadAll();
  }, []);

  // ================= CONTENT =================
  const submitContent = async (e) => {
    e.preventDefault();

    const fd = new FormData();
    fd.append("type", form.type);
    fd.append("title", form.title);
    fd.append("description", form.description);
    fd.append("position", form.position);
    if (form.image) fd.append("image", form.image);

    try {
      if (editContentId) {
        await API.put(`/content/${editContentId}`, fd);
      } else {
        await API.post("/content", fd);
      }

      resetContent();
      loadAll();
    } catch (err) {
      console.error(err);
    }
  };

  const resetContent = () => {
    setEditContentId(null);
    setForm({
      type: "banner",
      title: "",
      description: "",
      position: 1,
      image: null,
    });
  };

  const editContent = (item) => {
    setEditContentId(item.id);
    setForm({
      type: item.type,
      title: item.title,
      description: item.description,
      position: item.position,
      image: null,
    });
  };

  const deleteContent = async (id) => {
    await API.delete(`/content/${id}`);
    loadAll();
  };

  // ================= NEWS =================
  const submitNews = async (e) => {
    e.preventDefault();

    const fd = new FormData();
    fd.append("title", newsForm.title);
    fd.append("content", newsForm.content);
    if (newsForm.image) fd.append("image", newsForm.image);

    try {
      if (editNewsId) {
        await API.put(`/news/${editNewsId}`, fd);
      } else {
        const token = localStorage.getItem("token");
        await API.post("/news", fd, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }

      resetNews();
      loadAll();
    } catch (err) {
      console.error(err);
    }
  };

  const editNews = (n) => {
    setEditNewsId(n.id);
    setNewsForm({
      title: n.title,
      content: n.content,
      image: null,
    });
  };

  const deleteNews = async (id) => {
    await API.delete(`/news/${id}`);
    loadAll();
  };

  const resetNews = () => {
    setEditNewsId(null);
    setNewsForm({ title: "", content: "", image: null });
  };

  // ================= TEACHER =================
  const showTeacherTab = false;
  const submitTeacher = async (e) => {
    e.preventDefault();

    const fd = new FormData();
    fd.append("name", teacherForm.name);
    fd.append("position", teacherForm.position);
    fd.append("description", teacherForm.description);
    if (teacherForm.photo) fd.append("photo", teacherForm.photo);

    try {
      if (editTeacherId) {
        await API.put(`/teachers/${editTeacherId}`, fd);
      } else {
        await API.post("/teachers", fd);
      }

      resetTeacher();
      loadAll();
    } catch (err) {
      console.error(err);
    }
  };

  const editTeacher = (t) => {
    setEditTeacherId(t.id);
    setTeacherForm({
      name: t.name,
      position: t.position,
      description: t.description,
      photo: null,
    });
  };

  const deleteTeacher = async (id) => {
    await API.delete(`/teachers/${id}`);
    loadAll();
  };

  const resetTeacher = () => {
    setEditTeacherId(null);
    setTeacherForm({
      name: "",
      position: "",
      description: "",
      photo: null,
    });
  };

  //Galery
  const submitGallery = async (e) => {
    e.preventDefault();

    const fd = new FormData();
    fd.append("title", galleryForm.title);
    fd.append("category", galleryForm.category);

    // pastikan array images tidak kosong
    galleryForm.images.forEach((img) => {
      fd.append("images", img); // field harus sama persis dengan multer.array("images")
    });

    try {
      if (editGalleryId) {
        await API.put(`/gallery/${editGalleryId}`, fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      } else {
        await API.post("/gallery", fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      resetGallery();
      loadAll();
    } catch (err) {
      console.error(err);
    }
  };

  const resetGallery = () => {
    setEditGalleryId(null);
    setGalleryForm({ title: "", category: "", images: [] });
  };

  const [oldImages, setOldImages] = useState([]);

  const editGallery = (g) => {
    setEditGalleryId(g.id);
    setGalleryForm({
      title: g.title,
      category: g.category,
      images: [] // file baru belum dipilih
    });
    setOldImages(g.images || []); // simpan nama file lama
  };

  const deleteGallery = async (id) => {
    await API.delete(`/gallery/${id}`);
    loadAll();
  };  


  return (
    <div className="dashboard">
      <h2>📚 Admin Dashboard</h2>

      <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>

        {/* ================= CONTENT ================= */}
        <Tab eventKey="content" title="Content">
          <Form onSubmit={submitContent}>
            <Row>
              <Col md={3}>
                <Form.Select
                  value={form.type}
                  onChange={(e) => setForm({ ...form, type: e.target.value })}
                >
                  <option value="banner">Banner</option>
                  <option value="visi">Visi</option>
                  <option value="misi">Misi</option>
                  <option value="tentang">Tentang</option>
                  <option value="program">Program</option>
                </Form.Select>
              </Col>

              <Col md={3}>
                <Form.Control
                  placeholder="Judul"
                  value={form.title}
                  onChange={(e) => setForm({ ...form, title: e.target.value })}
                />
              </Col>

              <Col md={3}>
                <Form.Control
                  type="file"
                  onChange={(e) =>
                    setForm({ ...form, image: e.target.files[0] })
                  }
                />
              </Col>

              <Col md={3}>
                <Button type="submit">
                  {editContentId ? "Update" : "Simpan"}
                </Button>
                {editContentId && (
                  <Button
                    variant="secondary"
                    className="ms-2"
                    onClick={resetContent}
                  >
                    Batal
                  </Button>
                )}
              </Col>
            </Row>

            <Form.Control
              as="textarea"
              className="mt-2"
              value={form.description}
              onChange={(e) =>
                setForm({ ...form, description: e.target.value })
              }
            />
          </Form>

          <Table bordered className="mt-3">
            <thead>
              <tr>
                <th>Type</th>
                <th>Judul</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {content.map((c) => (
                <tr key={c.id}>
                  <td>{c.type}</td>
                  <td>{c.title}</td>
                  <td>
                    <Button size="sm" onClick={() => editContent(c)}>
                      Edit
                    </Button>
                    <Button
                      size="sm"
                      variant="danger"
                      className="ms-2"
                      onClick={() => deleteContent(c.id)}
                    >
                      Hapus
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Tab>

        {/* ================= NEWS ================= */}
        <Tab eventKey="news" title="Berita">
          <Form onSubmit={submitNews}>
            <Form.Control
              placeholder="Judul"
              value={newsForm.title}
              onChange={(e) =>
                setNewsForm({ ...newsForm, title: e.target.value })
              }
            />
            <Form.Control
              as="textarea"
              className="mt-2"
              placeholder="Isi berita"
              value={newsForm.content}
              onChange={(e) =>
                setNewsForm({ ...newsForm, content: e.target.value })
              }
            />
            <Form.Control
              type="file"
              className="mt-2"
              onChange={(e) =>
                setNewsForm({ ...newsForm, image: e.target.files[0] })
              }
            />

            <Button className="mt-2" type="submit">
              {editNewsId ? "Update News" : "Simpan News"}
            </Button>

            {editNewsId && (
              <Button
                className="mt-2 ms-2"
                variant="secondary"
                onClick={resetNews}
              >
                Batal
              </Button>
            )}
          </Form>

          <Table bordered className="mt-3">
            <thead>
              <tr>
                <th>Judul</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {news.map((n) => (
                <tr key={n.id}>
                  <td>{n.title}</td>
                  <td>
                    <Button size="sm" onClick={() => editNews(n)}>
                      Edit
                    </Button>
                    <Button
                      size="sm"
                      variant="danger"
                      className="ms-2"
                      onClick={() => deleteNews(n.id)}
                    >
                      Hapus
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Tab>

        {/* ================= TEACHER ================= */}
        {showTeacherTab && (
          <Tab eventKey="teacher" title="Guru">
            <Form onSubmit={submitTeacher}>
              <Form.Control
                placeholder="Nama"
                value={teacherForm.name}
                onChange={(e) =>
                  setTeacherForm({ ...teacherForm, name: e.target.value })
                }
              />
              <Form.Control
                className="mt-2"
                placeholder="Jabatan"
                value={teacherForm.position}
                onChange={(e) =>
                  setTeacherForm({ ...teacherForm, position: e.target.value })
                }
              />
              <Form.Control
                className="mt-2"
                as="textarea"
                placeholder="Deskripsi"
                value={teacherForm.description}
                onChange={(e) =>
                  setTeacherForm({
                    ...teacherForm,
                    description: e.target.value,
                  })
                }
              />
              <Form.Control
                className="mt-2"
                type="file"
                onChange={(e) =>
                  setTeacherForm({ ...teacherForm, photo: e.target.files[0] })
                }
              />

              <Button className="mt-2" type="submit">
                {editTeacherId ? "Update Guru" : "Simpan Guru"}
              </Button>

              {editTeacherId && (
                <Button
                  className="mt-2 ms-2"
                  variant="secondary"
                  onClick={resetTeacher}
                >
                  Batal
                </Button>
              )}
            </Form>

            <Table bordered className="mt-3">
              <thead>
                <tr>
                  <th>Nama</th>
                  <th>Jabatan</th>
                  <th>Aksi</th>
                </tr>
              </thead>
              <tbody>
                {teachers.map((t) => (
                  <tr key={t.id}>
                    <td>{t.name}</td>
                    <td>{t.position}</td>
                    <td>
                      <Button size="sm" onClick={() => editTeacher(t)}>
                        Edit
                      </Button>
                      <Button
                        size="sm"
                        variant="danger"
                        className="ms-2"
                        onClick={() => deleteTeacher(t.id)}
                      >
                        Hapus
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Tab>
        )}  
       {/* ================= GALLERY ================= */}
        <Tab eventKey="gallery" title="Galeri">
          <Form onSubmit={submitGallery}>
            <Form.Control
              className="mt-2"
              placeholder="Judul"
              value={galleryForm.title}
              onChange={(e) =>
                setGalleryForm({ ...galleryForm, title: e.target.value })
              }
            />
            {/* Preview gambar lama */}
            {editGalleryId && gallery
              .find(g => g.id === editGalleryId)
              ?.images?.map((img, idx) => (
                <div key={idx} style={{ display: "inline-block", margin: "5px" }}>
                  <img
                    src={`${process.env.REACT_APP_UPLOAD_URL}/uploads/${img}`}
                    alt="preview"
                    style={{ width: "80px", height: "80px", objectFit: "cover" }}
                  />
                </div>
            ))}
            <Form.Control
              className="mt-2"
              placeholder="Kategori"
              value={galleryForm.category}
              onChange={(e) =>
                setGalleryForm({ ...galleryForm, category: e.target.value })
              }
            />

            <Form.Control
              className="mt-2"
              type="file"
              multiple
              onChange={(e) => {
                setGalleryForm({ ...galleryForm, images: Array.from(e.target.files) });
                setOldImages([]); // hilangkan label lama kalau user pilih file baru
              }}
            />
            {oldImages.length > 0 && (
              <div className="mt-1 text-muted">
                File lama: {oldImages.join(", ")}
              </div>
            )}

            <Button className="mt-2" type="submit">
              {editGalleryId ? "Update Gallery" : "Simpan Gallery"}
            </Button>
            {editGalleryId && (
              <Button
                className="mt-2 ms-2"
                variant="secondary"
                onClick={resetGallery}
              >
                Batal
              </Button>
            )}
          </Form>

          <Table bordered className="mt-3">
            <thead>
              <tr>
                <th>Judul</th>
                <th>Kategori</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {gallery.map((g) => (
                <tr key={g.id}>
                  <td>{g.title}</td>
                  <td>{g.category}</td>
                  <td>
                    <Button size="sm" onClick={() => editGallery(g)}>
                      Edit
                    </Button>
                    <Button
                      size="sm"
                      className="ms-2"
                      variant="danger"
                      onClick={() => deleteGallery(g.id)}
                    >
                      Hapus
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Tab>
      </Tabs>
    </div>
  );
}